import Header from './Header';
import CookiePopUp from './CookiePopUp';
import CookiePolicy from './CookiePolicy';
import Footer from './Footer';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import CalculationDetails from './CalculationDetails';
import FallbackDetails from './FallbackDetails';
import IndexDetails from './IndexDetails';
import Disclaimer from './Disclaimer';
import Register from './Register';
import SignIn from './SignIn';
import UserAction from './UserAction';
import RFRCTab from './Tabs';
import LandingView from './LandingView';

const mapStateToProps = state => {
  return {
    ...state.common,
  }
};

const mapDispatchToProps = dispatch => ({
  
});

class App extends React.Component {

 
  render() {
    const classN = window.location.pathname === '/' ? 'minWid' : '';
    return (
      <div className={classN} >        
        <Header />
            <Switch>
              <Route exact path="/" component={LandingView} /> 
              <Route exact path="/Help" component={CalculationDetails} />
              <Route exact path="/Fallback" component={FallbackDetails} />
              <Route exact path='/CookiePolicy' component={CookiePolicy} />
              <Route exact path="/IndexDetails" component={IndexDetails} />
              <Route exact path="/Disclaimer" component={Disclaimer} />
              { this.props.isFirebaseEnabled && <Route exact path="/Register" component={Register} /> }
              { this.props.isFirebaseEnabled && <Route exact path="/SignIn" component={SignIn} /> }
              { this.props.isFirebaseEnabled && <Route exact path="/UserAction" component={UserAction} /> }              
              <Route exact path="/SONIA" component={RFRCTab} /> 
              <Route exact path="/SOFR" component={RFRCTab} /> 
              <Route exact path="/ESTR" component={RFRCTab} /> 
              <Route exact path="/TONAR" component={RFRCTab} /> 
              <Route exact path="*" component={LandingView} />             
            </Switch>

        <Footer {...this.props} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js